import { render, staticRenderFns } from "./SelectedVenue.vue?vue&type=template&id=a817da7e&scoped=true&"
import script from "./SelectedVenue.vue?vue&type=script&lang=js&"
export * from "./SelectedVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a817da7e",
  null
  
)

export default component.exports